import { createSelector } from '@ngrx/store';
import { selectIsBoardLoadingError } from '../board/board.selectors';
import { selectInventoriesLoadingError } from '../inventories/inventories.selectors';

export const selectIsBoardOrInventoriesLoadingError = createSelector(
  selectIsBoardLoadingError,
  selectInventoriesLoadingError,
  (boardLoadingError, inventoriesLoadingError) => boardLoadingError || !!inventoriesLoadingError
);
